module.exports = __webpack_public_path__ + "img/calendar.9a66a67f.svg";